import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Section } from '../components/ui/Section';
import { CTASection } from '../components/sections/CTASection';
import { ArrowRight, Loader2 } from 'lucide-react';
import { useServices } from '../hooks/useServices';
export function ServicesPage() {
  const {
    services,
    loading
  } = useServices();
  return <main className="pt-24" data-id="element-1475">
      <Section background="default" data-id="element-1476">
        <div className="max-w-4xl" data-id="element-1477">
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-[#0C0C0C] mb-6 leading-tight" data-id="element-1478">
            Our Services
          </motion.h1>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-600 leading-relaxed" data-id="element-1479">
            We design and build digital solutions that align with your business
            goals, user needs, and long-term growth strategy.
          </motion.p>
        </div>
      </Section>

      <Section background="white" data-id="element-1480">
        {loading ? <div className="flex items-center justify-center py-20 text-gray-400" data-id="element-1481">
            <Loader2 className="w-6 h-6 animate-spin mr-3" data-id="element-1482" />
            Loading services…
          </div> : services.length === 0 ? <div className="text-center py-20 text-gray-400" data-id="element-1483">
            <p className="text-lg font-medium" data-id="element-1484">No services available yet.</p>
            <p className="text-sm mt-2" data-id="element-1485">Check back soon!</p>
          </div> : <div className="space-y-24" data-id="element-1486">
            {services.map((service, index) => <motion.div key={service.id} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`} data-id="element-1487">
                <div className={index % 2 === 1 ? 'lg:order-2' : ''} data-id="element-1488">
                  <h2 className="text-3xl font-bold font-heading text-[#0C0C0C] mb-4" data-id="element-1489">
                    {service.title}
                  </h2>
                  <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-1490">
                    {service.description}
                  </p>
                  <Link to={`/services/${service.slug}`} className="inline-flex items-center gap-2 text-[#FF6600] font-medium hover:gap-3 transition-all" data-id="element-1491">
                    Learn more
                    <ArrowRight className="w-4 h-4" data-id="element-1492" />
                  </Link>
                </div>

                <div className={`relative h-[350px] rounded-2xl overflow-hidden ${index % 2 === 1 ? 'lg:order-1' : ''}`} data-id="element-1493">
                  {service.image ? <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-1494" /> : <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center" data-id="element-1495">
                      <span className="text-4xl font-bold text-gray-200 font-heading" data-id="element-1496">
                        {service.title.charAt(0)}
                      </span>
                    </div>}
                </div>
              </motion.div>)}
          </div>}
      </Section>

      <CTASection data-id="element-1497" />
    </main>;
}